import { render, staticRenderFns } from "./QueueItems.vue?vue&type=template&id=450f810f&scoped=true&"
import script from "./QueueItems.vue?vue&type=script&lang=js&"
export * from "./QueueItems.vue?vue&type=script&lang=js&"
import style0 from "./QueueItems.vue?vue&type=style&index=0&id=450f810f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f810f",
  null
  
)

export default component.exports